export enum ProductType {
    BASE = 'base',
    OPTION = 'option'
}

export interface IProduct {
    id: number;
    name: string;
    code: string;
    type: ProductType;
    description?: string;
    price?: number;
    group?: string;
    tags?: string[];
    form?: IForm | null;
    createdAt: Date;
    updatedAt: Date;
    deletedAt?: Date;
}

export interface IForm {
    id: number;
    name: string;
    // Add other form properties as needed
} 